export class CurrencyFormatter {
    static defaultCurrency = 'ARS';
    static defaultLocale = 'es-AR';
  
    static format(amount: number, currency?: string, locale?: string): string {
      if (isNaN(amount)) {
        return '';
      }
  
      return amount.toLocaleString(locale ?? this.defaultLocale, {
        style: 'currency',
        currency: currency ?? this.defaultCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }


  export const formatNumberAsEsAR = (value: number): string => {
    return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(value);
  };
  
  